import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCommonAnalyticsData, withPaymentAnalyticsField } from "../../../../../../../../utils/ym.helpers";
import { EAnalyticsActionConstant, EAnalyticsItemTypeConstant } from "../../../../../../../../constants";
export var getAnalyticsConverter = function getAnalyticsConverter(_ref) {
  var getWindow = _ref.getWindow,
    getAccountType = _ref.getAccountType,
    ymPushParams = _ref.ymPushParams;
  return function (props) {
    return _objectSpread(_objectSpread({}, props), {}, {
      onClick: function onClick() {
        var _props$onClick;
        ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
          action: EAnalyticsActionConstant.Click,
          item_type: EAnalyticsItemTypeConstant.Button,
          button_text: props.children,
          object_type: EAnalyticsItemTypeConstant.Widget,
          widget_name: 'способ оплаты'
        })));
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props);
      }
    });
  };
};